//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonClassifier from '@/components/nav_common/CommonClassifier'
import { Author } from '@/models'

export default {
  data () {
    return {
      contents: [
        // {
        //   title: '作者',
        //   classList: [
        //   ]
        // }
      ]
    }
  },
  components: {
    CommonClassifier
  },

  beforeCreate () {
    Author.getHotAuthors(1, 30).then(result => {
      let content = { title: '作者', routePrev: '/author/'}

      content.classList = result.map(item => {
        return {
          id: item.id,
          text: item.get('name')
        }
      })

      this.contents.unshift(content)
    })
  },
}



// WEBPACK FOOTER //
// ./src/components/nav_author/AuthorRight.vue